angular.module('content.widgets.loWidget', [
  'content.widgets.LOWidgetController'
])

/**
 * The loWidget provides a preview
 * of the loWidget item type
 *
 * @class LOWidget
 * @constructor
 * @module content.widgets.loWidget
 * @example
 *   <lo-widget
 *     model="form.model">
 *   </lo-widget>
 */
.directive('loWidget', [
  '$state',
  function ($state) {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        model: '='
      },
      templateUrl: function () {
        if ($state.params.widgetMode === 'edit' || $state.params.stateMode === 'edit') {
          return 'content/source/content/widgets/loWidget/lo-widget-edit.html';
        }
        return 'content/source/content/widgets/loWidget/lo-widget.html';
      },
      controller: 'LOWidgetController'
    };
  }
]);
